"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts hyphenated headers like `Content-Type` into `content-type`.
 */
function normalize(str) {
    if (typeof str !== "string") {
        throw new TypeError("Header Fields must be strings.");
    }
    str = str.toLowerCase();
    if (str === "referrer") {
        str = "referer";
    }
    return str;
}
exports.normalize = normalize;
//# sourceMappingURL=index.js.map